<div class="ng-autocomplete {{hasErrors ? 'error' : ''}} {{(config.allowBrowserLocation ? 'active-location-select' : '')}}" id="autoComplete-{{config.property}}"
  [formGroup]="form">
  @if (config.allowBrowserLocation) {
    <div class="currentLocation"
    (click)="setCurrentLocation()" title="{{'select_my_location'|translate}}"></div>
  }

  @if (!config.formArray) {
    <div >
      <ng-autocomplete
        #inputAutoComplete
        placeholder="{{config.placeholder | translate | ucFirst}}"
        (inputChanged)="search($event)"
        (selected)="getAddress($event)"
        [customFilter]="customFilter"
        (inputCleared)="clear()"
        (closed)="selectFirstOption($event)"
        [focusFirst]="true"
        [data]="data"
        [debounceTime]="500"
        [minQueryLength]="autocompleteStartAt"
        [searchKeyword]="'description'"
        [isLoading]="loading"
        [itemTemplate]="itemTemplate"
        [formControlName]="config.property"
        [class]="(config.allowBrowserLocation? 'currentLocationAutocomplete' : '')"
        [notFoundTemplate]="notFoundTemplate">
      </ng-autocomplete>
    </div>
  }

  @if (config.formArray) {
    <div formArrayName="stopOvers">
      <ng-autocomplete
        #inputAutoComplete
        (inputChanged)="search($event)"
        placeholder="{{config.placeholder | translate | ucFirst}}"
        (selected)="getAddress($event)"
        [customFilter]="customFilter"
        (inputCleared)="clear()"
        (closed)="selectFirstOption($event)"
        [focusFirst]="true"
        [data]="data"
        [debounceTime]="500"
        [minQueryLength]="autocompleteStartAt"
        [searchKeyword]="'description'"
        [isLoading]="loading"
        [itemTemplate]="itemTemplate"
        [formControlName]="config.property"
        [class]="(config.allowBrowserLocation? 'currentLocationAutocomplete' : '')"
        [notFoundTemplate]="notFoundTemplate">
      </ng-autocomplete>
    </div>
  }
  <ng-template #itemTemplate let-item>
    <a class="{{((item.types || []).join(' '))}} {{item.recentAddress ? 'recent-address' : ''}}">
      <span class="icon"><app-svg-icon [icon]="item.recentAddress ? 'clock' : getIcon(item.types, item.type)"></app-svg-icon></span>
      <span [innerHTML]="item.description | ucFirst"></span>
    </a>
  </ng-template>
  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="'autocomplete_no_address_found' | translate | ucFirst"></div>
  </ng-template>
</div>
<app-field-error
  class="{{hasErrors ? 'ng-autocomplete-error' : ''}}"
  [config]="config" (validityChanged)="validityChanged($event)"
  (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, 'serviceAreaModal')">
</app-field-error>

